

<script>
// CommitChart.js
import { Bar ,mixins } from 'vue-chartjs';
import zoom from 'chartjs-plugin-zoom'
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    // Overwriting base render method with actual data.
    this.addPlugin(zoom);
    this.renderBarChart();
  },
  methods: {
    renderBarChart() {
      this.renderChart(this.chartData, this.options)
    }
  },
  watch: {
    data: function() {
      this.$data._chart.destroy();
      this.renderBarChart();
      this.$data._chart.resetZoom();
    }
  }

}

</script>